import React from 'react'
import { compose, pure } from 'recompose'
import { translate } from 'react-i18next'
import styles from './floatLabelPasswordComponent.scss'
import IconCheck from '../../../assets/icons/iconCheck.svg'
import PropTypes from 'prop-types'

export function FloatLabelPassword (props) {
  const { t } = props
  const placeholder = props.input.placeholder || props.placeholder
  const type = props.input.type || props.type
  const label = props.input.label || props.label
  const meta = props.input.meta || props.meta

  const errorList = [
    'passwordRequired',
    'needsMoreThanEight',
    'needsUppercase',
    'needsLowercase',
    'needsSpecialCharacter'
  ]

  const metaErrors = meta && meta.touched && meta.error
  return (
    <div className={[props.wrapperStyle, styles.floatLabel].join(' ')}>
      <input
        {...props.input}
        placeholder={placeholder}
        type={type}
        id={props.input.name}
      />
      <label htmlFor={props.input.name}>
        {label}
      </label>
    </div>
  )
}

FloatLabelPassword.propTypes = {
  wrapperStyle: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  t: PropTypes.func.isRequired
}

export default compose(translate(), pure)(FloatLabelPassword)



// WEBPACK FOOTER //
// ./src/forms/components/floatLabelPassword/floatLabelPasswordComponent.js